// the actions column's field from the old MUI grids, kept so users' saved layouts still match it
export const ADMIN_ACTIONS_COLUMN_FIELD = 'another.action.navigation';
